import React from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { Form, Formik } from "formik";
import {
  newVendorMerchantFields,
  getFormFields,
  getFormValidations,
  getInitialFormValues,
} from "../../../../Dashboard/Views/AddNewVendor/formFields";
import * as Yup from "yup";

import "./style.css";

const dunsConfig = [
  {
    name: "duns",
    type: "text",
    length: 4,
    placeHolder: "123456789",
    label: "Duns #",
    required: true,
    initialValue: "",
    validation: Yup.number()
      .typeError("Duns # must be 9 digit number")
      .required("Duns number is required")
      .min(9, "Duns # should be 9 digit."),
    maxLength: 9,
  },
];
const fulfillmentTypeConfig = [
  {
    name: "merchandiseType",
    type: "select",
    length: 4,
    label: "Vendor Fulfillment Type",
    required: true,
    initialValue: "",
    validation: Yup.string().required(
      "The vendor fulfillment type is required."
    ),
    selectOptions: [
      {
        optionValue: "VDF",
        optionName: "Vendor Direct Fulfillment",
      },
      {
        optionValue: "Owned Inventory",
        optionName: "Traditional Vendor",
      },
    ],
    ["data-testid"]: "addExistingVendor_form_connection_select_merchandiseType",
  },
];

const formConfigArray = [
  ...dunsConfig,
  ...fulfillmentTypeConfig,
  ...newVendorMerchantFields,
];
const formValidationRules = getFormValidations(formConfigArray);
const initialFormValues = getInitialFormValues(formConfigArray);

const AccessForNewProduct = ({
  submitHandler,
  duns,
  actionInProgress,
  errMsg,
}) => {
  return (
    <Formik
      initialValues={
        duns ? { ...initialFormValues, duns: duns } : initialFormValues
      }
      validationSchema={formValidationRules}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        let dataToSubmit = {
          ...values,
        };
        submitHandler(dataToSubmit);
        setSubmitting(false);
      }}
      render={({ isSubmitting, isValid, dirty, resetForm }) => (
        <Form>
          <Modal.Body className="selectNewAccessType_modalBody">
            <Row>
              <p style={{ fontSize: 15 }}>
                In order to add a new product type or fulfillment type, please
                provide the following additional information:
              </p>
            </Row>
            <Row style={{ padding: 0 }}>
              {duns
                ? getFormFields(
                    dunsConfig.map((x) => ({ ...x, disabled: true }))
                  ).map((field) => field)
                : getFormFields(dunsConfig).map((field) => field)}
            </Row>
            <Row style={{ padding: 0 }}>
              {getFormFields(fulfillmentTypeConfig).map((field) => field)}
            </Row>
            <Row style={{ padding: 0 }}>
              {getFormFields(newVendorMerchantFields).map((field) => field)}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="accessRequest_modalFooter_container">
              <div className="requestError">{errMsg}</div>
              <Button
                className="button-primary-md"
                type="submit"
                disabled={
                  !isValid || !dirty || isSubmitting || actionInProgress
                }
              >
                SUBMIT
              </Button>
            </div>
          </Modal.Footer>
        </Form>
      )}
    />
  );
};

export default AccessForNewProduct;
